import { Company } from './api/common/interfaces/company.interface'
import { PersonType } from './api/common/interfaces/person-type.enum'

/**
 * Natureza jurídica da conta ativa.
 *
 * A plataforma é modelada em Organization (titular) > Company (filiais) > usuários
 * (via UserCompany, N:N). O `personType` mora na Organization como registro do
 * titular e é espelhado na Company porque é a company ATIVA que o frontend tem em
 * mãos — `switchCompany` troca de company e pode até trocar de organization
 * (MASTER), então ler a natureza do usuário ou da org da sessão daria a resposta
 * errada.
 *
 * `User.personType` NÃO serve para isso: descreve a pessoa que fez login, e todo
 * funcionário é FISICA mesmo numa conta PJ.
 */
export function isIndividualCompany(company?: Company | null): boolean {
    return company?.personType === PersonType.FISICA
}

/** Documento do titular: CNPJ na PJ, CPF na PF. */
export function companyDocument(company?: Company | null): string | null {
    if (!company) return null
    const document = isIndividualCompany(company) ? company.cpf : company.cnpj
    return document?.trim() || null
}

/** Rótulo do documento, para labels e mensagens de erro. */
export function companyDocumentLabel(company?: Company | null): string {
    return isIndividualCompany(company) ? 'CPF' : 'CNPJ'
}

/** Rótulo do nome: razão social na PJ, nome completo na PF. */
export function companyNameLabel(company?: Company | null): string {
    return isIndividualCompany(company) ? 'Nome completo' : 'Razão Social'
}

/**
 * Pessoa física não tem filial: quem é PF é a própria pessoa, e uma segunda
 * unidade com o mesmo CPF não existe juridicamente.
 */
export function canHaveBranches(company?: Company | null): boolean {
    return !isIndividualCompany(company)
}
